import { render, staticRenderFns } from "./ThumbsDownSvg.vue?vue&type=template&id=95a29240&"
import script from "./ThumbsDownSvg.vue?vue&type=script&lang=ts&"
export * from "./ThumbsDownSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports